var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AudioUnitTracks_adapter;
import { FieldParameterTracks } from "../timeline/ParameterTracks";
export class AudioUnitTracks extends FieldParameterTracks {
    constructor(adapter, boxAdapters) {
        super(adapter.box.graph, adapter.box.tracks, boxAdapters);
        _AudioUnitTracks_adapter.set(this, void 0);
        __classPrivateFieldSet(this, _AudioUnitTracks_adapter, adapter, "f");
    }
    get audioUnitBox() { return __classPrivateFieldGet(this, _AudioUnitTracks_adapter, "f").box; }
}
_AudioUnitTracks_adapter = new WeakMap();
